module.exports = __webpack_public_path__ + "0d92dca6572f84e16c96217c9807b7ef.png";